import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import usePageStore from '../Page/pageStore';
import { useLocation } from 'react-router-dom';
import { getPath } from '../Router/Router';
import { API, getAbsoluteSetupArray, getBackgroundPosition, isMobileWidth, MOBILE_SAFE_RESIZE, } from '../globalUtils';
import useDataStore from '../Data/dataStore';
import ShaderAnimation from './ShaderAnimation';
import gsap from 'gsap';
// WARNING! Because of page duplicator we can have product_details at unwanted places! See the fix below
const ProductBackgroundSwitch = () => {
    const data = useDataStore((state) => state.data);
    const { shownPage, activeSection, pageChangeCount } = usePageStore();
    const movementRotation = useRef([0, 0, 0]); // third one is the refresh counter
    const prevMovementRotation = useRef([0, 0, 1]); // third one is the scale of the projection
    const [_, setRender] = useState(0);
    const [restartCounter, setRestartCounter] = useState(0);
    const [paused, setPaused] = useState(false);
    const product = (data[API.products]?.products ?? []).reduce((acc, item) => (item.slug === shownPage ? item : acc), undefined);
    const containerRef = useRef(null);
    const activeSectionRef = useRef(0);
    const firstReveal = useRef(true);
    const positionRef = useRef();
    const positionRefChangeCounter = useRef(0);
    const urlPath = getPath(useLocation().pathname);
    const { slug, logo } = product ?? {};
    // Make sure that the info belongs to the right section type!
    const section = data[slug]?.page_sections?.[activeSection];
    const storyPosition = section?.type === 'home_text'
        ? section?.story?.flexible_background_position
        : undefined;
    const productDetailsPosition = section?.type === 'product_details'
        ? section?.product_details?.flexible_background_position
        : undefined;
    const position = slug ? storyPosition || productDetailsPosition : undefined;
    // TODO: watch the number of renders on this component!
    if (position) {
        //check against the default position on mobiles
        positionRef.current = isMobileWidth() ? '0,0,1,0' : position;
    }
    const [mobileView, setMobileView] = useState(isMobileWidth());
    const mobileViewRef = useRef(mobileView);
    mobileViewRef.current = mobileView;
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        onResize();
        return () => {
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        const mobile = isMobileWidth();
        if (mobile && !mobileViewRef.current) {
            setMobileView(true);
        }
        if (!mobile && mobileViewRef.current) {
            setMobileView(false);
        }
    };
    useEffect(() => {
        firstReveal.current = activeSection < 0;
        //positionRef.current = null;
        prevMovementRotation.current = [0, 0, 1];
        setTimeout(() => setRestartCounter((x) => x + 1));
    }, [shownPage, pageChangeCount]);
    useEffect(() => {
        checkFadeState();
    }, [activeSection, mobileView, position]);
    const fadeDuration = 0.6;
    const fadeEase = 'power1.inOut';
    const checkFadeState = () => {
        if (mobileView) {
            if (activeSection === 0) {
                fadeIn();
            }
            else {
                fadeOut();
            }
        }
        else {
            if (position) {
                fadeIn();
            }
            else {
                fadeOut();
            }
        }
    };
    const fadeIn = () => {
        console.log('+++++++');
        if (containerRef.current) {
            const canvas = containerRef.current.querySelector('canvas');
            if (canvas) {
                gsap.killTweensOf(canvas);
                gsap.to(canvas, {
                    opacity: 1,
                    duration: fadeDuration,
                    ease: fadeEase,
                });
                setPaused(false);
            }
        }
    };
    const fadeOut = () => {
        console.log('------');
        if (containerRef.current) {
            const canvas = containerRef.current.querySelector('canvas');
            if (canvas) {
                gsap.killTweensOf(canvas);
                gsap.to(canvas, {
                    opacity: 0,
                    duration: fadeDuration,
                    ease: fadeEase,
                    onComplete: onFadeOutFinished,
                });
            }
        }
    };
    const onFadeOutFinished = () => {
        positionRef.current = '0,0,1,0';
        setPaused(true);
    };
    useEffect(() => {
        if (positionRef.current) {
            if (containerRef.current) {
                const canvas = containerRef.current.querySelector('canvas');
                if (canvas) {
                    const setupArray = getAbsoluteSetupArray(positionRef.current);
                    const css = getBackgroundPosition(setupArray);
                    if (firstReveal.current) {
                        css.transition = '';
                    }
                    else {
                        css.transition = 'transform 1.4s cubic-bezier(.62,0,.28,1.01)';
                        const currentRotation = [
                            parseFloat(setupArray[0]),
                            parseFloat(setupArray[1]),
                            parseFloat(setupArray[2]),
                        ];
                        const rotationDiff = [
                            prevMovementRotation.current[0] - currentRotation[0],
                            prevMovementRotation.current[1] - currentRotation[1],
                        ];
                        // check scale for rotation direction
                        const scaleDirectionFlip = currentRotation[2] > prevMovementRotation.current[2] ? 1 : -1;
                        movementRotation.current = [
                            prevMovementRotation.current[0] < currentRotation[0]
                                ? Math.abs(rotationDiff[0]) * scaleDirectionFlip
                                : Math.abs(rotationDiff[0]) * -1 * scaleDirectionFlip,
                            prevMovementRotation.current[1] < currentRotation[1]
                                ? Math.abs(rotationDiff[1]) * scaleDirectionFlip
                                : Math.abs(rotationDiff[1]) * -1 * scaleDirectionFlip,
                            movementRotation.current[2] + 1,
                        ];
                        prevMovementRotation.current = currentRotation;
                        setRender((x) => x + 1);
                    }
                    Object.assign(canvas.style, css);
                }
                firstReveal.current = false;
            }
        }
        else {
            //firstReveal.current = true;
        }
    }, [positionRef.current, activeSection, shownPage]);
    if (!product)
        return null;
    return positionRef.current ? (_jsx("div", { className: "product-background-animation", ref: containerRef, children: _jsx("div", { className: "product-background-animation-wrapper", children: _jsx(ShaderAnimation, { displayedCurve: logo, hide: false, paused: paused, allowIntroZoom: activeSection <= 0, movementRotation: movementRotation.current, blockMouseInteractions: true, closeDisplayedCurve: !position, restartCounter: restartCounter }) }) })) : null;
};
export default ProductBackgroundSwitch;
